import apiClient from "./apiClient";
// ✅ Fetch all blogs

// ✅ Fetch all consultations with pagination
export const fetchConsultationsAPI = (page = 1) => {
  return apiClient.get(`/tailmission/api/v1/admin/appointments?page=${page}`);
};

// ✅ Fetch a single consultation by ID
export const fetchConsultationByIdAPI = (id) => {
  return apiClient.get(`/tailmission/api/v1/admin/appointments/${id}`);
};

// ✅ Delete a consultation by ID
export const deleteConsultationAPI = (id) => {
  return apiClient.delete(`/tailmission/api/v1/admin/appointments/${id}`);
};

// ✅ Update a consultation by ID
export const updateConsultationAPI = (id, data) => {
  // Check if data is FormData (for proper backend format)
  const isFormData = data instanceof FormData;

  const config = {
    headers: {
      ...(isFormData && { 'Content-Type': 'multipart/form-data' })
    }
  };

  return apiClient.put(`/tailmission/api/v1/admin/appointments/${id}`, data, config);
};
